var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Translate } from "../../I18N";
import { socket } from "../../socket";
import { bindActionCreators } from 'redux';
import { postToOcr, getOcrStatus } from "../actions/ocrActions";
import { ocrStatusTips } from "../utils/ocrStatusTips";
import { reloadDocument } from "../actions/documentActions";





const formatDate = (time, locale) => {
  const date = new Date(time);
  return date.toLocaleString(locale);
};

const mapStateToProps = ({ settings, locale }) => {
  const toggleOCRButton = settings.collection.get('ocrServiceEnabled');
  return {
    ocrIsToggled: toggleOCRButton || false,
    locale
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ loadDocument: reloadDocument }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);



// eslint-disable-next-line max-statements
const OCRStatus = ({ file, ocrIsToggled, locale, loadDocument }) => {
  if (!ocrIsToggled) return null;

  const [ocrStatus, setOcrStatus] = useState({ status: 'loading', lastUpdated: Date.now() });

  const listenOnSuccess = (_id) => {
    if (file._id === _id) {
      setOcrStatus({ status: 'ocrComplete', lastUpdated: Date.now() });
      loadDocument(file.entity);
    }
  };

  const listenOnError = (_id) => {
    if (file._id === _id) setOcrStatus({ status: 'ocrError', lastUpdated: Date.now() });
  };

  useEffect(() => {
    getOcrStatus(file.filename || '').
    then(({ status, lastUpdated }) => {
      setOcrStatus({ status, lastUpdated });
      if (status === 'inQueue') {
        socket.on('ocr:ready', listenOnSuccess);
        socket.on('ocr:error', listenOnError);
      }
    }).
    catch(() => {
      setOcrStatus({ status: 'ocrError', lastUpdated: Date.now() });
    });

    return () => {
      socket.off('ocr:ready', listenOnSuccess);
      socket.off('ocr:error', listenOnError);
    };
  }, [file]);

  const handleClick = () => {
    setOcrStatus({ status: 'inQueue', lastUpdated: Date.now() });
    postToOcr(file.filename || '').
    then(() => {
      socket.on('ocr:ready', listenOnSuccess);
      socket.on('ocr:error', listenOnError);
    }).
    catch(() => {});
  };

  const lastUpdated = formatDate(ocrStatus.lastUpdated, locale);

  let statusDisplay = /*#__PURE__*/_jsx("div", {});
  let tip;

  switch (ocrStatus.status) {
    case 'loading':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "status" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Loading"), "\xA0..."));



      break;

    case 'noOCR':
      statusDisplay = /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-default", onClick: () => handleClick() }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "OCR PDF"));


      tip = ocrStatusTips.noOcr();
      break;

    case 'inQueue':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "status" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "In OCR queue")));



      tip = ocrStatusTips.lastUpdated(lastUpdated);
      break;

    case 'unsupported_language':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "status" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Unsupported OCR language")));



      tip = ocrStatusTips.unsupportedLang(file.language || 'other');
      break;

    case 'cannotProcess':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "status" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "OCR error")));



      tip = ocrStatusTips.cantProcess(lastUpdated);
      break;

    case 'ocrError':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "ocr-error" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Could not be processed")));



      tip = ocrStatusTips.cantProcess(lastUpdated);
      break;

    case 'withOCR':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "status" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "OCR"), "\xA0\u2714"));



      tip = ocrStatusTips.lastUpdated(lastUpdated);
      break;

    case 'ocrComplete':
      statusDisplay = /*#__PURE__*/
      _jsx("div", { className: "complete" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "OCR completed"), "\xA0\u2714"));



      break;

    default:
      break;}


  return /*#__PURE__*/(
    _jsx("div", { className: "ocr-service-display" }, void 0,
    statusDisplay,
    tip && /*#__PURE__*/_jsx("div", { className: "ocr-tooltip" }, void 0, tip)));


};

const container = connector(OCRStatus);
export { container as OCRStatus };